import React, { Component } from "react";
import Modal from "react-responsive-modal";
import "./ManualEntry.css";
import { Row, Col } from "react-bootstrap";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { translations } from "../containers/assets/translations";
import { B2B_PROXY } from "../containers/assets/config";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import { ToastContainer, ToastStore } from "react-toasts";
import { FormGroup, FormControl, ControlLabel, Button } from "react-bootstrap";
import axios from "axios";

export default class ManualEntry extends Component {
  constructor(props) {
    super(props);
    this.saveManualEntry = this.saveManualEntry.bind(this);
    this.handleChangeOfInputSearchFields =
      this.handleChangeOfInputSearchFields.bind(this);

    this.handleChangeOfCombo = this.handleChangeOfCombo.bind(this);
    this.getTicket = this.getTicket.bind(this);
    this.deleteManualEntry = this.deleteManualEntry.bind(this);
    const today = new Date();
    var day = ("0" + today.getDate()).slice(-2);
    var month = ("0" + (today.getMonth() + 1)).slice(-2);
    const todayFormat = today.getFullYear() + "-" + month + "-" + day;
    const expiration = today.getFullYear() + 1 + "-" + month + "-" + day;
    this.state = {
      Countries: [],
      Docs: [],
      companyAbbreviation: this.props.companyAbbreviation,
      AccomPass: [],
      AccomVeh: [],
      AgeType: [],
      VehType: [],
      TicketNumberME: "",
      PNRME: "",
      SurnameME: "",
      NameME: "",
      MaidenME: "",
      BirthDateME: "",
      BirthPlaceME: "",
      TravelDocNumberME: "",
      TravelDocIssueDateME: "",
      OccupationME: "",
      ComingFromME: "",
      GoingToME: "",
      AddressMoroccoME: "",
      PhoneDuringStayME: "",
      VisitReasonME: "",
      CabinSeatNumberME: "",
      BerthME: "",
      VisaNumberME: "",
      username: this.props.username,
      userGroup: this.props.userGroup,
      password: this.props.password,
      RegistrationPlatesME: "",
      DriverNameME: "",
      LengthME: "",
      HeightME: "",
      ModelME: "",
      BrandME: "",
      loadingSpinner: false,
      AgeCateg: "",
      Gender: "",
      Nation: "",
      SpecialServ: "NO",
      DocType: "",
      ResidCountry: "",
      AccomTypePass: "",
      AccomTypeVeh: "",
      bookId: "",
      IssDateME: todayFormat,
      ExpDateME: expiration,
    };
  }

  handleChangeOfCombo(event) {
    let fieldName = event.target.name;
    let fieldValue = event.target.value;
    this.setState({ [fieldName]: fieldValue });
  }

  handleChangeOfInputSearchFields(event) {
    let fieldName = event.target.name;
    let fieldValue = event.target.value;
    this.setState({ [fieldName]: fieldValue });
  }

  getTicket = () => {
    let TicketNumberME = this.state.TicketNumberME;
    let username = this.props.username;
    let userGroup = this.props.userGroup;
    let password = this.props.password;
    let ItineraryID = this.props.ItineraryID;
    let lang =
      localStorage.getItem("lang") === "EN" ||
        localStorage.getItem("lang") === "FR" ||
        localStorage.getItem("lang") === "ES"
        ? localStorage.getItem("lang")
        : "EN";
    this.setState({ loadingSpinner: true });
    axios
      .post(B2B_PROXY + "/TicketEnquiryForTickNum", {
        TicketNumberME,
        username,
        userGroup,
        password,
        ItineraryID,
        lang,
      })
      .then((res) => {
        if (res.data[0] === "000") {
          this.setState({ PNRME: res.data[4] });
          ToastStore.success(res.data[1]);
          this.setState({ loadingSpinner: false });
          if (res.data[2].length > 0) {
            this.setState({ SurnameME: res.data[2][0].Surname });
            this.setState({ NameME: res.data[2][0].Name });
            this.setState({ MaidenME: res.data[2][0].MaidenName });
            this.setState({
              BirthDateME:
                res.data[2][0].BirthDate.substr(0, 4) +
                "-" +
                res.data[2][0].BirthDate.substr(-4, 2) +
                "-" +
                res.data[2][0].BirthDate.substr(-2),
            });
            this.setState({ BirthPlaceME: res.data[2][0].BirthPlace });
            this.setState({ TravelDocNumberME: res.data[2][0].PassportNumber });
            this.setState({
              TravelDocIssueDateME:
                res.data[2][0].PassportDelDate.substr(0, 4) +
                "-" +
                res.data[2][0].PassportDelDate.substr(-4, 2) +
                "-" +
                res.data[2][0].PassportDelDate.substr(-2),
            });
            this.setState({ Gender: res.data[2][0].Gender });
            this.setState({ SpecialServ: res.data[2][0].SpecialServicesReq });
            this.setState({ OccupationME: res.data[2][0].Occupation });
            this.setState({ ComingFromME: res.data[2][0].CommingFrom });
            this.setState({ GoingToME: res.data[2][0].GoingTo });
            this.setState({
              AddressMoroccoME: res.data[2][0].AddressInMorocco,
            });
            this.setState({
              PhoneDuringStayME: res.data[2][0].PhoneDuringStay,
            });
            this.setState({ AccomTypePass: res.data[2][0].AgeCategory });
            this.setState({ VisitReasonME: res.data[2][0].MainReasonForVisit });
            this.setState({
              CabinSeatNumberME: res.data[2][0].CabinSeatNumber,
            });
            this.setState({ BerthME: res.data[2][0].Berth });
            this.setState({ VisaNumberME: res.data[2][0].VisaNumber });
            this.setState({ bookId: res.data[2][0].BookID });

            this.setState({ Nation: res.data[2][0].Nationality });
            this.setState({
              ResidCountry: res.data[2][0].CountryOfUsualResidence,
            });

            for (let i = 0; i < this.state.Docs.length; i++) {
              if (
                res.data[2][0].DocType.trim() === this.state.Docs[i].TMSACode
              ) {
                this.setState({
                  DocType: res.data[2][0].DocType.trim(),
                });
              }
            }

            for (let i = 0; i < this.state.Countries.length; i++) {
              if (this.state.Countries[i].Code === res.data[2][0].Nationality) {
                this.setState({
                  Nation: res.data[2][0].Nationality,
                });
              }

              if (
                this.state.Countries[i].ThreeLtrCode ===
                res.data[2][0].CountryOfUsualResidence
              ) {
                this.setState({
                  ResidCountry: res.data[2][0].CountryOfUsualResidence,
                });
              }
            }

            for (let i = 0; i < this.state.AgeType.length; i++) {
              if (this.state.AgeType[i].Code === res.data[2][0].AgeCategory) {
                this.setState({
                  AgeCateg: res.data[2][0].AgeCategory,
                });
              }
            }

            for (let i = 0; i < this.state.AccomPass.length; i++) {
              if (
                this.state.AccomPass[i].Code ===
                res.data[2][0].AccommodationType
              ) {
                this.setState({
                  AccomTypePass: res.data[2][0].AccommodationType,
                });
              }
            }
          } else if (res.data[3].length > 0) {
            this.setState({
              RegistrationPlatesME: res.data[3][0].RegistrationNumber,
            });
            this.setState({ DriverNameME: res.data[3][0].DriverName });
            this.setState({ LengthME: res.data[3][0].Length });
            this.setState({ HeightME: res.data[3][0].Height });
            this.setState({ ModelME: res.data[3][0].Model });
            this.setState({ BrandME: res.data[3][0].Brand });
            this.setState({ AccomTypeVeh: res.data[3][0].VehicleType });
            this.setState({ bookId: res.data[3][0].BookID });

            for (let i = 0; i < this.state.AccomVeh.length; i++) {
              if (
                this.state.AccomVeh[i].Code === res.data[3][0].AccommodationType
              ) {
                this.setState({
                  AccomTypeVeh: res.data[3][0].AccommodationType,
                });
              }
            }
          }
        } else {
          ToastStore.error(res.data.StatusMessage);
          this.setState({ loadingSpinner: false });
        }
      });
  };

  deleteManualEntry = () => {
    const data = {
      manualEntryPassenger: this.props.manualEntryPassenger,
      username: this.state.username,
      userGroup: this.state.userGroup,
      password: this.state.password,
      TicketNumberME: this.state.TicketNumberME,
      ItineraryID: this.props.ItineraryID,
      SailID: this.props.SailID,
      PNRME: this.state.PNRME,
      SurnameME: this.state.SurnameME,
      NameME: this.state.NameME,
      MaidenME: this.state.MaidenME,
      BirthDateME: this.state.BirthDateME,
      BirthPlaceME: this.state.BirthPlaceME,
      TravelDocNumberME: this.state.TravelDocNumberME,
      TravelDocIssueDateME: this.state.TravelDocIssueDateME,
      OccupationME: this.state.OccupationME,
      ComingFromME: this.state.ComingFromME,
      GoingToME: this.state.GoingToME,
      AddressMoroccoME: this.state.AddressMoroccoME,
      PhoneDuringStayME: this.state.PhoneDuringStayME,
      VisitReasonME: this.state.VisitReasonME,
      CabinSeatNumberME: this.state.CabinSeatNumberME,
      BerthME: this.state.BerthME,
      VisaNumberME: this.state.VisaNumberME,
      companyAbbreviation: this.props.companyAbbreviation,
      RegistrationPlatesME: this.state.RegistrationPlatesME,
      DriverNameME: this.state.DriverNameME,
      LengthME: this.state.LengthME,
      HeightME: this.state.HeightME,
      ModelME: this.state.ModelME,
      BrandME: this.state.BrandME,
      AgeCateg: this.state.AgeCateg,
      Gender: this.state.Gender,
      Nation: this.state.Nation,
      SpecialServ: this.state.SpecialServ,
      DocType: this.state.DocType,
      ResidCountry: this.state.ResidCountry,
      AccomTypePass: this.state.AccomTypePass,
      AccomTypeVeh: this.state.AccomTypeVeh,
    };

    if (this.state.TicketNumberME !== "" && this.state.PNRME !== "") {
      this.setState({ loadingSpinner: true });
      axios
        .post(B2B_PROXY + "/DeleteTicket", {
          data,
        })
        .then((res) => {
          if (res.data.StatusCode === "000") {
            ToastStore.success(res.data.StatusMessage);
            this.setState({ loadingSpinner: false });
          } else {
            ToastStore.error(res.data.StatusMessage);
            this.setState({ loadingSpinner: false });
          }
        });
    }
  };

  saveManualEntry = () => {
    const data = {
      manualEntryPassenger: this.props.manualEntryPassenger,
      username: this.state.username,
      userGroup: this.state.userGroup,
      password: this.state.password,
      TicketNumberME: this.state.TicketNumberME,
      ItineraryID: this.props.ItineraryID,
      SailID: this.props.SailID,
      PNRME: this.state.PNRME,
      SurnameME: this.state.SurnameME,
      NameME: this.state.NameME,
      MaidenME: this.state.MaidenME,
      BirthDateME: this.state.BirthDateME,
      BirthPlaceME: this.state.BirthPlaceME,
      TravelDocNumberME: this.state.TravelDocNumberME,
      TravelDocIssueDateME: this.state.TravelDocIssueDateME,
      OccupationME: this.state.OccupationME,
      ComingFromME: this.state.ComingFromME,
      GoingToME: this.state.GoingToME,
      AddressMoroccoME: this.state.AddressMoroccoME,
      PhoneDuringStayME: this.state.PhoneDuringStayME,
      VisitReasonME: this.state.VisitReasonME,
      CabinSeatNumberME: this.state.CabinSeatNumberME,
      BerthME: this.state.BerthME,
      VisaNumberME: this.state.VisaNumberME,
      companyAbbreviation: this.props.companyAbbreviation,

      RegistrationPlatesME: this.state.RegistrationPlatesME,
      DriverNameME: this.state.DriverNameME,
      LengthME: this.state.LengthME,
      HeightME: this.state.HeightME,
      ModelME: this.state.ModelME,
      BrandME: this.state.BrandME,
      AgeCateg: this.state.AgeCateg,
      Gender: this.state.Gender,
      Nation: this.state.Nation,
      SpecialServ: this.state.SpecialServ,
      DocType: this.state.DocType,
      ResidCountry: this.state.ResidCountry,
      AccomTypePass: this.state.AccomTypePass,
      AccomTypeVeh: this.state.AccomTypeVeh,
      IssDateME: this.state.IssDateME,
      ExpDateME: this.state.ExpDateME,
      IsMRZScannedME: "0",
    };
    this.setState({ loadingSpinner: true });
    axios.post(B2B_PROXY + "/EmbDataInsert", { data }).then((res) => {
      if (res.data.StatusCode === "000") {
        ToastStore.success("Booking/Ticket Inserted");
        this.props.fetchReservation();
        this.setState({ loadingSpinner: false });
      } else if (typeof res.data.StatusMessage === "undefined") {
        ToastStore.error("Booking/Ticket did not Insert. Please try again");
        this.setState({ loadingSpinner: false });
      } else {
        ToastStore.error(res.data.StatusMessage);
        this.setState({ loadingSpinner: false });
      }
    });
  };

  componentDidMount() {
    axios.get(B2B_PROXY + "/Countries").then((res) => {
      const CountriesMap = res.data.map((obj) => ({
        Code: obj.Code,
        ThreeLtrCode: obj.ThreeLtrCode,
        Name: obj.Name,
      }));
      let sortedCountries = CountriesMap.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      );
      this.setState({ Countries: sortedCountries });
    });
    let companyAbbr = this.state.companyAbbreviation;

    axios.get(B2B_PROXY + "/DocIndex").then((res) => {
      const DocsMap = res.data.map((obj) => ({
        TMSACode: obj.TMSACode,
        Description: obj.Description,
      }));
      this.setState({ Docs: DocsMap });
    });
    axios.get(B2B_PROXY + "/AccomsVeh").then((res) => {
      const AgeType = res.data[0].map((obj) => ({
        Type: obj.Type,
        Code: obj.Code,
        Name: obj.Name,
      }));
      this.setState({ AgeType });
      const VehType = res.data[1].map((obj) => ({
        Type: obj.Type,
        Code: obj.Code,
        Name: obj.Name,
      }));
      this.setState({ AccomTypeVeh: VehType });
    });
    axios.post(B2B_PROXY + "/AccomPerComp", { companyAbbr }).then((res) => {
      const AccomPass = res.data.AccomPass.map((obj) => ({
        Type: obj.Type,
        Company: obj.Company,
        Code: obj.Code,
        Name: obj.Name,
        PortGenericCode: obj.PortGenericCode,
        PortGenericName: obj.PortGenericName,
      }));
      const AccomVeh = res.data.AccomVeh.map((obj) => ({
        Type: obj.Type,
        Company: obj.Company,
        Code: obj.Code,
        Name: obj.Name,
        PortGenericCode: obj.PortGenericCode,
        PortGenericName: obj.PortGenericName,
      }));
      this.setState({ AccomPass });
      this.setState({ AccomVeh });
    });
  }

  render() {
    let lang = this.props.lang;
    var countriesSize = this.state.Countries.length;
    let optionItems = [];
    for (var i = 0; i < countriesSize; i++) {
      optionItems.push({
        // @ts-ignore
        abbr: this.state.Countries.Code,
        // @ts-ignore
        country: this.state.Countries.Name,
      });
    }

    return (
      <Modal
        open={this.props.isManualEntryOpen}
        onClose={this.props.onCloseManualEntry}
        center
      >
        <Loader fullPage loading={this.state.loadingSpinner} />
        <Col className="HeaderTicks">{translations[lang]["Manual Entry"]}</Col>
        <Row>
          <Col md={4}>
            <FormGroup className="left">
              <ControlLabel>{translations[lang]["Ticket Number"]}</ControlLabel>
              <FormControl
                className="well"
                value={this.state.TicketNumberME}
                onChange={(event) => {
                  this.handleChangeOfInputSearchFields(event);
                }}
                name="TicketNumberME"
                type="text"
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup className="left">
              <ControlLabel>{translations[lang]["Company"]}</ControlLabel>
              <FormControl
                className="well"
                readOnly
                value={this.props.companyAbbreviation}
                type="text"
                name="Company"
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup className="left">
              <ControlLabel>{translations[lang]["PNR"]}</ControlLabel>
              <FormControl
                className="well"
                name="PNRME"
                value={this.state.PNRME}
                onChange={(event) => {
                  this.handleChangeOfInputSearchFields(event);
                }}
                type="text"
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <RadioGroup
              name="manualEntryInputType"
              value={this.props.manualEntryRadioValue}
              onChange={this.props.handleChangeOfManualEntryRadioButton}
            >
              <FormControlLabel
                onClick={this.props.onClickManualEntryPassenger}
                value="passenger"
                control={
                  <Radio
                    color="primary"
                    checked={this.props.manualEntryPassenger}
                  />
                }
                label={translations[lang]["Passenger"]}
              />

              <FormControlLabel
                onClick={this.props.onClickManualEntryVehicle}
                value="vehicle"
                control={
                  <Radio
                    color="primary"
                    checked={this.props.manualEntryVehicle}
                  />
                }
                label={translations[lang]["Vehicle"]}
              />
            </RadioGroup>
          </Col>
          <Col md={4}>
            <FormGroup className="left">
              <ControlLabel>{translations[lang]["Issue Date"]}</ControlLabel>
              <FormControl
                className="well"
                name="IssDateME"
                value={this.state.IssDateME}
                onChange={(event) => {
                  this.handleChangeOfInputSearchFields(event);
                }}
                type="date"
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup className="left">
              <ControlLabel>
                {translations[lang]["Expiration Date"]}
              </ControlLabel>
              <FormControl
                className="well"
                name="ExpDateME"
                value={this.state.ExpDateME}
                onChange={(event) => {
                  this.handleChangeOfInputSearchFields(event);
                }}
                type="date"
              />
            </FormGroup>
          </Col>
          {/* <Col md={4}>
            <Button
              className="btn btn-primary btn btn-lg "
              bsSize="large"
              type="button"
              onClick={this.getTicket}
            >
              {translations[lang]["Search Ticket"]}
            </Button>
          </Col>*/}
        </Row>
        {this.props.manualEntryPassenger ? (
          <Row className="TicketBlock">
            <Col md={12} className="RowME">
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>{translations[lang]["Surname"]}</ControlLabel>
                  <FormControl
                    className="well"
                    name="SurnameME"
                    type="text"
                    value={this.state.SurnameME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>{translations[lang]["firstName"]}</ControlLabel>
                  <FormControl
                    className="well"
                    name="NameME"
                    type="text"
                    value={this.state.NameME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Maiden Name"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="MaidenME"
                    value={this.state.MaidenME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left MEform">
                  <ControlLabel>{translations[lang]["Age/Cat"]}</ControlLabel>
                  <FormControl
                    componentClass="select"
                    name="AgeCateg"
                    value={this.state.AgeCateg}
                    onChange={this.handleChangeOfCombo}
                  >
                    <option>Select Category</option>
                    {this.state.AgeType.map((AgeType, index) => {
                      return (
                        <option
                          key={"ageCategory" + index}
                          value={AgeType.Code}
                        >
                          {AgeType.Name}
                        </option>
                      );
                    })}
                  </FormControl>
                </FormGroup>
              </Col>
            </Col>
            <Col md={12} className="RowME">
              <Col md={3} sm={6}>
                <FormGroup className="left MEform">
                  <ControlLabel>{translations[lang]["Gender"]}</ControlLabel>
                  <FormControl
                    componentClass="select"
                    name="Gender"
                    value={this.state.Gender}
                    onChange={this.handleChangeOfCombo}
                  >
                    <option>Select Gender</option>
                    <option value="M">{translations[lang]["Male"]} </option>
                    <option value="F">{translations[lang]["Female"]} </option>
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Birth Date"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="BirthDateME"
                    value={this.state.BirthDateME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="date"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left MEform">
                  <ControlLabel>
                    {translations[lang]["Nationality"]}
                  </ControlLabel>
                  <FormControl
                    componentClass="select"
                    value={this.state.Nation}
                    name="Nation"
                    onChange={this.handleChangeOfCombo}
                  >
                    <option>Select Nationality </option>
                    {this.state.Countries.map((Country, index) => {
                      return (
                        <option key={index} value={Country.Code}>
                          {Country.Name}
                        </option>
                      );
                    })}
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Birth Place"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="BirthPlaceME"
                    value={this.state.BirthPlaceME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
            </Col>
            <Col md={12} className="RowME">
              <Col md={3} sm={6}>
                <FormGroup className="left MEform">
                  <ControlLabel>
                    {translations[lang]["Special Service Req."]}
                  </ControlLabel>
                  <FormControl
                    componentClass="select"
                    value={this.state.SpecialServ}
                    name="SpecialServ"
                    onChange={this.handleChangeOfCombo}
                  >
                    <option value="NO">{translations[lang]["NO"]} </option>
                    <option value="YES">{translations[lang]["YES"]} </option>
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left MEform">
                  <ControlLabel>
                    {translations[lang]["Document Type"]}
                  </ControlLabel>
                  <FormControl
                    componentClass="select"
                    value={this.state.DocType}
                    name="DocType"
                    onChange={this.handleChangeOfCombo}
                  >
                    {this.state.Docs.map((Document, index) => {
                      return (
                        <option key={index} value={Document.TMSACode}>
                          {Document.Description}
                        </option>
                      );
                    })}
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Travel Doc. Number"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="TravelDocNumberME"
                    value={this.state.TravelDocNumberME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Travel Doc. Issue Date"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="TravelDocIssueDateME"
                    value={this.state.TravelDocIssueDateME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="date"
                  />
                </FormGroup>
              </Col>
            </Col>
            <Col md={12} className="RowME">
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Occupation"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="OccupationME"
                    value={this.state.OccupationME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Coming From"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="ComingFromME"
                    value={this.state.ComingFromME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>{translations[lang]["Going To"]}</ControlLabel>
                  <FormControl
                    className="well"
                    name="GoingToME"
                    value={this.state.GoingToME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left MEform">
                  <ControlLabel>
                    {translations[lang]["Residence Country"]}
                  </ControlLabel>
                  <FormControl
                    componentClass="select"
                    value={this.state.ResidCountry}
                    name="ResidCountry"
                    onChange={this.handleChangeOfCombo}
                  >
                    <option>Select Country</option>
                    {this.state.Countries.map((Country, index) => {
                      return (
                        <option
                          key={"ResCountry" + Country.ThreeLtrCode}
                          value={Country.Code}
                        >
                          {Country.Name}
                        </option>
                      );
                    })}
                  </FormControl>
                </FormGroup>
              </Col>
            </Col>
            <Col md={12} className="RowME">
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Address in Morocco"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="AddressMoroccoME"
                    value={this.state.AddressMoroccoME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Phone During Stay"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="PhoneDuringStayME"
                    value={this.state.PhoneDuringStayME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="number"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Visit Reason"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="VisitReasonME"
                    value={this.state.VisitReasonME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left MEform">
                  <ControlLabel>
                    {translations[lang]["Accomodation Type"]}
                  </ControlLabel>
                  <FormControl
                    componentClass="select"
                    value={this.state.AccomTypePass}
                    name="AccomTypePass"
                    onChange={this.handleChangeOfCombo}
                  >
                    <option>Select Accommodation</option>
                    {this.state.AccomPass.map((AccomPass, index) => {
                      return (
                        <option key={index} value={AccomPass.Code}>
                          {AccomPass.Name}
                        </option>
                      );
                    })}
                  </FormControl>
                </FormGroup>
              </Col>
            </Col>
            <Col md={12} className="RowME">
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Cabin/Seat Number"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="CabinSeatNumberME"
                    value={this.state.CabinSeatNumberME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>{translations[lang]["Berth"]}</ControlLabel>
                  <FormControl
                    className="well"
                    name="BerthME"
                    value={this.state.BerthME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={6}>
                <FormGroup className="left">
                  <ControlLabel>
                    {translations[lang]["Visa Number"]}
                  </ControlLabel>
                  <FormControl
                    className="well"
                    name="VisaNumberME"
                    value={this.state.VisaNumberME}
                    onChange={(event) => {
                      this.handleChangeOfInputSearchFields(event);
                    }}
                    type="text"
                  />
                </FormGroup>
              </Col>
            </Col>
          </Row>
        ) : null}
        {this.props.manualEntryVehicle ? (
          <Row className="TicketBlock">
            <Col md={12} className="clear">
              <FormGroup className="left MEform">
                <ControlLabel>
                  {translations[lang]["Vehicle Type"]}
                </ControlLabel>
                <FormControl
                  componentClass="select"
                  value={this.state.AccomTypeVeh}
                  name="AccomTypeVeh"
                  onChange={this.handleChangeOfCombo}
                >
                  {this.state.AccomVeh.map((AccomVeh, index) => {
                    return (
                      <option key={AccomVeh.Code} value={AccomVeh.Code}>
                        {AccomVeh.Name}
                      </option>
                    );
                  })}
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={12} className="clear">
              <FormGroup className="left">
                <ControlLabel>
                  {translations[lang]["Registration Plates"]}
                </ControlLabel>
                <FormControl
                  className="well"
                  name="RegistrationPlatesME"
                  value={this.state.RegistrationPlatesME}
                  onChange={(event) => {
                    this.handleChangeOfInputSearchFields(event);
                  }}
                  type="text"
                />
              </FormGroup>
            </Col>
            <Col md={12} className="clear">
              <FormGroup className="left">
                <ControlLabel>{translations[lang]["Driver Name"]}</ControlLabel>
                <FormControl
                  className="well"
                  name="DriverNameME"
                  value={this.state.DriverNameME}
                  onChange={(event) => {
                    this.handleChangeOfInputSearchFields(event);
                  }}
                  type="text"
                />
              </FormGroup>
            </Col>
            <Col md={12} className="clear">
              <FormGroup className="left">
                <ControlLabel>{translations[lang]["Length (cm)"]}</ControlLabel>
                <FormControl
                  className="well"
                  name="LengthME"
                  value={this.state.LengthME}
                  onChange={(event) => {
                    this.handleChangeOfInputSearchFields(event);
                  }}
                  type="text"
                />
              </FormGroup>
            </Col>
            <Col md={12} className="clear">
              <FormGroup className="left">
                <ControlLabel>{translations[lang]["Height (cm)"]}</ControlLabel>
                <FormControl
                  className="well"
                  name="HeightME"
                  value={this.state.HeightME}
                  onChange={(event) => {
                    this.handleChangeOfInputSearchFields(event);
                  }}
                  type="text"
                />
              </FormGroup>
            </Col>
            <Col md={12} className="clear">
              <FormGroup className="left">
                <ControlLabel>{translations[lang]["Model"]}</ControlLabel>
                <FormControl
                  className="well"
                  name="ModelME"
                  value={this.state.ModelME}
                  onChange={(event) => {
                    this.handleChangeOfInputSearchFields(event);
                  }}
                  type="text"
                />
              </FormGroup>
            </Col>
            <Col md={12} className="clear">
              <FormGroup className="left ">
                <ControlLabel>{translations[lang]["Brand"]}</ControlLabel>
                <FormControl
                  className="well"
                  name="BrandME"
                  value={this.state.BrandME}
                  onChange={(event) => {
                    this.handleChangeOfInputSearchFields(event);
                  }}
                  type="text"
                />
              </FormGroup>
            </Col>
          </Row>
        ) : null}
        <Row>
          <div className="col-md-3 col-sm-6 col-xs-12">
            <Button
              className="btn-danger redButton"
              bsSize="large"
              type="button"
              onClick={() => {
                this.deleteManualEntry();
              }}
            >
              Delete
            </Button>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-12">
            <Button
              className="btn-primary"
              bsSize="large"
              type="button"
              onClick={() => {
                this.saveManualEntry();
              }}
            >
              Save
            </Button>
          </div>
        </Row>
        <ToastContainer
          store={ToastStore}
          className="toaster"
          lightBackground
          position={
            // @ts-ignore
            ToastContainer.POSITION.TOP_CENTER
          }
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ManualEntry.js